import { render, staticRenderFns } from "./award-guide-popup.vue?vue&type=template&id=b6b5b2e4&scoped=true&lang=pug&"
import script from "./award-guide-popup.vue?vue&type=script&lang=js&"
export * from "./award-guide-popup.vue?vue&type=script&lang=js&"
import style0 from "./award-guide-popup.vue?vue&type=style&index=0&id=b6b5b2e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5b2e4",
  null
  
)

export default component.exports